import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isVideoAccountAndDimension } from '../../../../../config/report-predicates/isVideoAccountAndDimension';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import * as FIELDS from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import footerColumnDefinitions from './footerColumnDefinitions';
import graph from './graph';
import { OS_VERSION_VIDEO_REPORT_ID } from './osVersionVideoReportId';
import { customColumns, defaultColumns } from './reportPresets';

export const osVersionVideoReportConfig = {
    id: OS_VERSION_VIDEO_REPORT_ID,
    label: 'OS Versions',
    permissions: [REPORT_PERMISSION.ADS_CONSOLE_VIDEO_CAMPAIGNS],
    accountConfigurations: { [FEATURE_FLAGS.ONLY_PERFORMANCE_REPORTS]: 'false' },
    visibilityCondition: isVideoAccountAndDimension,
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-report-by-os-version-performance',
    graph,
    rowIdField: FIELDS.COMPOUND_OS_VERSION_CODE.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: footerColumnDefinitions,
    filters: [
        { id: FILTER_TYPE.PLATFORM },
        { id: FILTER_TYPE.OS_VERSION },
        {
            id: FILTER_TYPE.ACCOUNT_MANAGER,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
        {
            id: FILTER_TYPE.SALES_PERSON,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
        {
            id: FILTER_TYPE.ACCOUNT_MANAGER_GROUP,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
        {
            id: FILTER_TYPE.SALES_GROUP,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
    ],
};

export default osVersionVideoReportConfig;
